import { createContext } from "react";

const PantallaContext = createContext();
export default PantallaContext;
